/* Newsletter-Anmeldung über den Nerd Mailer
 *
 * Gegenstück zu snippets/newsletter-mailer.liquid. Schickt die Adresse an den
 * App Proxy und zeigt danach den Hinweis auf die Bestätigungsmail:
 *
 *   POST /apps/newsletter/api/subscribe   {"email": "...", "source": "footer"}
 *
 * Der Pfad läuft über den Shopify App Proxy: same-origin, von Shopify
 * HMAC-signiert, kein Schlüssel im Frontend.
 *
 * ── Warum die Datei aus layout/theme.liquid geladen wird ────────────────────
 *
 * Sie bedient MEHRERE Formulare auf derselben Seite - Footer und Popup stehen
 * gleichzeitig im Dokument. Ein <script> im Snippet liefe bei mehrfachem
 * Rendern doppelt, und jeder Klick löste dann zwei Anmeldungen aus.
 *
 * ── Warum ein MutationObserver ──────────────────────────────────────────────
 *
 * Das Popup dieses Themes ist ein Custom Element, das seinen Inhalt erst
 * einhängt, wenn es sich öffnet. Wer nur beim Laden einmal über das Dokument
 * geht, findet dessen Formular nie - und das Popup ist die Stelle mit der
 * höchsten Anmeldequote. `verdrahte()` ist deshalb mehrfach aufrufbar und
 * merkt sich, was es schon kennt.
 *
 * ── Zur Fehlerbehandlung ────────────────────────────────────────────────────
 *
 * Der Server antwortet absichtlich gleich, egal ob die Adresse neu, gesperrt
 * oder schon angemeldet ist - sonst wäre das Formular eine Auskunft darüber,
 * wer Kunde ist. Wir zeigen deshalb bei jeder erfolgreichen Antwort denselben
 * Hinweis.
 */
(function () {
  'use strict';

  var MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ENDPUNKT = '/apps/newsletter/api/subscribe';
  var VERDRAHTET = 'nlMailerVerdrahtet';

  function verdrahte(wurzel) {
    var behaelter = (wurzel || document).querySelectorAll('[data-nl-mailer]');

    Array.prototype.forEach.call(behaelter, function (el) {
      // Doppelte Verdrahtung führt zu doppelten Anmeldungen pro Klick.
      if (el.dataset[VERDRAHTET] === '1') return;

      var form = el.querySelector('.nl-mailer-form');
      var feld = el.querySelector('input[name="email"]');
      var knopf = el.querySelector('button[type="submit"]');
      var fehlerEl = el.querySelector('[data-nl-fehler]');
      var erfolgEl = el.querySelector('[data-nl-erfolg]');
      if (!form || !feld) return;

      el.dataset[VERDRAHTET] = '1';

      var quelle = el.dataset.quelle || 'footer';
      // Sprache der Storefront - siehe Anmerkung im Snippet.
      var sprache = el.dataset.sprache || '';
      var textEmail = el.dataset.fehlerEmail || 'Bitte gib eine gültige E-Mail-Adresse ein.';
      var textAllgemein = el.dataset.fehlerAllgemein || 'Das hat gerade nicht geklappt.';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        absenden();
      });

      async function absenden() {
        setFehler('');

        var email = (feld.value || '').trim();
        // Nur eine grobe Vorprüfung, damit offensichtliche Tippfehler nicht
        // erst eine Anfrage kosten. Verbindlich prüft der Server.
        if (!email || !MAIL.test(email)) {
          setFehler(textEmail);
          feld.focus();
          return;
        }

        setBusy(true);
        try {
          var token = null;
          if (window.vmTurnstile && window.vmTurnstile.holeToken) {
            token = await window.vmTurnstile.holeToken();
          }

          var res = await fetch(ENDPUNKT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              email: email,
              source: quelle,
              sprache: sprache,
              turnstileToken: token,
            }),
          });
          var daten = await res.json().catch(function () { return null; });

          if (res.ok && daten && daten.ok) {
            zeigeErfolg();
            return;
          }
          if (daten && daten.error === 'invalid_email') {
            setFehler(textEmail);
            return;
          }
          setFehler(textAllgemein);
        } catch (err) {
          console.error('[newsletter] Anmeldung fehlgeschlagen', err);
          setFehler(textAllgemein);
        } finally {
          setBusy(false);
        }
      }

      function zeigeErfolg() {
        form.hidden = true;
        setFehler('');
        if (!erfolgEl) return;
        erfolgEl.hidden = false;
        // Der Footer liegt weit unten; ohne Fokus bemerkt ein Screenreader den
        // Wechsel nicht, und mit Tastatur landet man sonst im Nichts.
        erfolgEl.setAttribute('tabindex', '-1');
        erfolgEl.focus();
        // Merker fürs Popup: Wer sich gerade eingetragen hat, soll nicht beim
        // nächsten Seitenaufruf erneut gefragt werden. Dasselbe Signal, das
        // dieses Theme auch für sein eigenes Formular benutzt.
        try {
          localStorage.setItem('theme:popup-filled', 'true');
        } catch (e) {
          /* Privater Modus - dann eben nicht. */
        }
      }

      function setFehler(text) {
        if (!fehlerEl) return;
        // Nur den Textknoten füllen, nicht den Behälter - darin steckt das
        // Banner-Markup des Themes samt Icon.
        var ziel = fehlerEl.querySelector('[data-nl-fehler-text]') || fehlerEl;
        ziel.textContent = text;
        fehlerEl.hidden = !text;
      }

      function setBusy(busy) {
        if (!knopf) return;
        knopf.disabled = busy;
        knopf.setAttribute('aria-busy', busy ? 'true' : 'false');
      }
    });
  }

  /**
   * Das Popup gar nicht erst aufgehen lassen, wenn es unnötig ist.
   *
   * Zwei Fälle, die Liquid nicht sieht:
   *
   *  - Der Merkzettel-Cookie. Die Bestätigungsseite liegt auf
   *    hedwig.viamundi.de, der Shop auf viamundi.de; beide teilen sich die
   *    übergeordnete Domain, deshalb kann der Nerd Mailer den Cookie dort
   *    setzen und wir ihn hier lesen. Beim Abmelden wird er wieder gelöscht,
   *    damit ein Rückkehrer erneut eingeladen wird.
   *
   *    Der Name stammt aus dem getDigital-Theme, wo dieser Weg entstanden ist.
   *    Er ist bewusst für beide Shops derselbe: Es sind getrennte Domains und
   *    damit getrennte Cookies, und ein Umbenennen würde die Merkzettel aller
   *    bisherigen getDigital-Abonnenten entwerten - die bekämen das Fenster
   *    dann alle noch einmal.
   *
   *  - Wer aus dem Newsletter kommt (utm_source=nerd-mailer), hat ihn schon.
   */
  function unterdrueckePopup() {
    var hatCookie = document.cookie.split(';').some(function (c) {
      return c.trim().indexOf('gd_nl=') === 0;
    });
    var ausNewsletter = false;
    try {
      ausNewsletter = new URLSearchParams(location.search).get('utm_source') === 'nerd-mailer';
    } catch (e) {
      /* Uralte Browser - dann eben nicht. */
    }
    if (!hatCookie && !ausNewsletter) return;

    var popup = document.getElementById('newsletter-drawer');
    if (popup && popup.parentNode) popup.parentNode.removeChild(popup);
  }

  function start() {
    unterdrueckePopup();
    verdrahte(document);

    // Das Popup hängt sein Formular erst beim Öffnen ein.
    if (!window.MutationObserver) return;
    new MutationObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (eintraege[i].addedNodes.length) {
          verdrahte(document);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
